import { useAuthStore } from '@/v2/store/shared/auth-store';
import { doc, setDoc, deleteDoc } from 'firebase/firestore';
import { eduDb } from '@/firebase';
import { api } from '@/v2/plugins/axios';
export class Registration {
	id = null;
	studentName = null;
	gender = null;
	nationality = null;
	email = null;
	learningPath = null;
	status = null;
	paymentStatus = null;
	paymentMethod = null;
	country = null;
	birthDate = null;
	phoneNumber = null;
	degree = null;
	specialization = null;
	jobTitle = null;
	company = null;

	constructor(obj) {
		Object.keys(obj).forEach((key) => {
			this[key] = obj[key];
		});
	}

	async update(data) {
		const authStore = useAuthStore();
		const tenantId = authStore.tenantId;

		const registrationDocRef = doc(eduDb, `tenants/${tenantId}/registrations`, `${this.id}`);
		await setDoc(registrationDocRef, data, { merge: true });
	}

	async remove() {
		const authStore = useAuthStore();
		const tenantId = authStore.tenantId;

		const registrationDocRef = doc(eduDb, `tenants/${tenantId}/registrations`, `${this.id}`);
		await deleteDoc(registrationDocRef);
	}

	async setPaymentStatus(status) {
		const data = {
			paymentStatus: status,
			paymentDate: new Date().toISOString(),
		};

		if (this.status === registrationStatusEnum.PendingPayment) {
			data.status = registrationStatusEnum.Completed;
		}

		const authStore = useAuthStore();
		const tenantId = authStore.tenantId;

		const registrationDocRef = doc(eduDb, `tenants/${tenantId}/registrations`, `${this.id}`);
		await setDoc(registrationDocRef, data, { merge: true });

		this.paymentStatus = status;
		this.paymentDate = data.paymentDate;
		if (this.status === registrationStatusEnum.PendingPayment) {
			this.status = registrationStatusEnum.Completed;
		}
	}

	static async exportData(filters = {}, tenantId) {
		const authStore = useAuthStore();
		const idToken = await authStore.getIdToken();
		const res = await api.post(
			`${process.env.MIX_API_FUNCTION_URL_EXECUTE_ACTION}`,
			{
				filters,
			},
			{
				params: {
					actionName: 'exportHdtcRegistrations',
				},
				headers: {
					tenantId,
					userId: 'temp',
					'x-firebase-token': idToken,
				},
			},
		);
		return res.data?.result?.downloadURL;
	}

	static async create(data) {
		const authStore = useAuthStore();
		const tenantId = `${authStore.tenantId}`;

		const res = await api.post(`${process.env.MIX_API_FUNCTION_URL_EXECUTE_ACTION}`, data, {
			params: {
				actionName: 'createOrUpdateHdtcRegistration',
			},
			headers: {
				tenantid: tenantId,
				userid: data.createdBy,
				'x-channel-id': 'whatsapp', // TODO: send it in data and add it to the headers
			},
		});
		return res.data?.result?.downloadURL;
	}
}

export const registrationStatusEnum = Object.freeze({
	Pending: 'Pending',
	PendingPayment: 'Pending Payment',
	Paid: 'Paid',
});

export const registrationStatusBadgeVariant = Object.freeze({
	[registrationStatusEnum.Pending]: 'warning',
	[registrationStatusEnum.PendingPayment]: 'warning',
	[registrationStatusEnum.Paid]: 'success',
});

export const registrationPaymentStatusEnum = Object.freeze({
	Pending: 'Pending',
	Success: 'Success',
	Failed: 'Failed',
});

export const registrationPaymentMethodEnum = Object.freeze({
	OnlinePayment: 'Online Payment',
	// OnSitePayment: 'On-Site Payment',
	// Empty: 'empty',
});

export const registrationPaymentStatusBadgeVariant = Object.freeze({
	[registrationPaymentStatusEnum.Pending]: 'warning',
	[registrationPaymentStatusEnum.Success]: 'success',
	[registrationPaymentStatusEnum.Failed]: 'error',
});

export const degreeEnum = Object.freeze({
	HighSchool: 'HighSchool',
	Diploma: 'Diploma',
	Bachelor: 'Bachelor',
	Master: 'Master',
	PhD: 'PhD',
});

export const countryEnum = Object.freeze({
	KSA: 'KSA',
	UAE: 'UAE',
});
